PJQ.views.email = {};

PJQ.views.email.ComposeEmailModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-compose-email'),
        subTemplates: {
            emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
        },
        header: "Send Email",
        enableCC: true,
        subject: '',
        onSave: null,
        onSaveWait: null,
        onCancel: null,
        maxWidth: '1200px'
    },
    events: {
        'keyup .input-share-search': 'searchChanged',
        'focus .input-share-search': 'focusSearch',
        'click .share-email-delete': 'deleteEmail',
        'click .modal-share-send': 'send',
        'click .modal-share-cancel': 'cancel',
        'mousedown .modal-dialog': 'checkIsFocused',
        'click .btn-add-project-contact': 'addProjectContact'
    },
    beforeModalCreated: function () {
        this.selectedEmailsTo = [];
        this.selectedEmailsCC = [];
        this.focusType = null;
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    afterRender: function () {
        this.bodyEditor = new PJQ.inputs.HTMLEditor({
            el: this.$('.email-body'),
            editorHeight: 300,
            isHideTokens: true,
            onChange: _.bind(function (contents) {

            }, this)
        });
    },
    focusSearch: function (e) {
        this.focusType = $(e.currentTarget).data('email-line');
        if (this.contactEmailSelector != null)
            this.contactEmailSelector.remove();

        this.contactEmailSelector = new PJQ.views.email.ContactSearchSelect({
            el: this.focusType === "to" ? this.$('.contact-emails-to') : this.$('.contact-emails-cc'),
            selectedEmails: this.focusType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC,
            search: this.getFocusSearchText(),
            project: this.options.project,
            onAdd: _.bind(function (email) {
                this.addEmail(email);
            }, this)
        });
    },
    checkIsFocused: function (e) {
        if (this.$(e.target).closest('.share-contact').length > 0) {
            return;
        }

        // Removes contact email selector if not selecting a contact, or entering an email
        let target = $(e.target),
            targetParent = $(e.target.parentElement);

        if (this.focusType != null
            && !target.hasClass('share-contact')
            && !targetParent.hasClass('share-contact')
            && !target.hasClass('input-share-search')
            && !target.hasClass('share-contact-email')
            && !target.hasClass('share-email-entry')
            && !target.hasClass('share-contact-name')) {
            this.contactEmailSelector.remove();
            this.focusType = null;
        }
    },
    getFocusSearchText: function () {
        return this.focusType != null ? this.$('.input-share-search[data-email-line="' + this.focusType + '"]').val().toLowerCase() : this.$('.input-share-search').val().toLowerCase();
    },
    searchChanged: function () {
        this.contactEmailSelector.searchChanged(this.getFocusSearchText());
    },
    renderRecipientCount: function () {
        let emailCount = _.size(this.selectedEmailsTo) + _.size(this.selectedEmailsCC);
        this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
    },
    addProjectContact: function (e) {
        let $target = $(e.currentTarget),
            emailLine = $target.data('email-line');

        new PJQ.views.contacts.SelectContactsModal({
            hideEmails: emailLine === 'to' ? this.selectedEmailsTo : this.selectedEmailsCC,
            subtitle: `Add Project Contacts to the ${emailLine === 'to' ? 'To' : 'CC'} line`,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            canSwitchContext: false,
            showAddress: false,
            isSingleChoice: false,
            saveButtonText: "Add",
            onSave: (newContacts) => {
                this.focusType = emailLine;
                _.each(newContacts, (contact) => {
                    let email = contact.get('email').toLowerCase();
                    if (_.size(email) === 0) {
                        return;
                    }

                    if (emailLine === 'to') {
                        this.selectedEmailsTo.push(email);
                    } else {
                        this.selectedEmailsCC.push(email);
                    }
                    this.addEmail(email, true);
                });
                this.focusType = null;
            }
        });
    },
    addEmail: function (email, shouldNotFocus) {
        this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails[data-email-line="' + (this.focusType) + '"]'), {
            email: email
        });
        this.$('.input-share-search').val('');
        this.$('.modal-share-send').prop('disabled', false);
        this.renderRecipientCount();

        if (!shouldNotFocus) {
            this.$('.input-share-search[data-email-line="' + this.focusType + '"]').focus();
        }
    },
    deleteEmail: function (e) {
        let emailContainer = $(e.currentTarget).closest('.share-email'),
            emailLineType = $(e.currentTarget).closest('.share-selected-emails').data('email-line'),
            emailArray = emailLineType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC;
        emailArray = _.without(emailArray, emailContainer.data('email').toLowerCase());

        if (emailLineType === "to")
            this.selectedEmailsTo = emailArray
        else
            this.selectedEmailsCC = emailArray

        emailContainer.remove();
        this.searchChanged();
        this.$('.modal-share-send').prop('disabled', _.size(emailArray) === 0);
        this.renderRecipientCount();
    },
    validate: function () {
        return true;
    },
    send: function () {
        let $subject = this.$('.input-share-subject'),
            data = {
                toEmails: this.selectedEmailsTo,
                ccEmails: this.selectedEmailsCC,
                subject: $subject.val(),
                body: this.bodyEditor.getValue()
            };

        let isSubjectValid = _.size(data.subject) > 0;
        PJQ.helpers.inputHelpers.setInputError($subject, isSubjectValid);
        if (!isSubjectValid) {
            return;
        }

        if (typeof this.options.onSave === 'function') {
            this.options.onSave(data);
            this.removeModal();
        } else if (typeof this.options.onSaveWait === 'function') {
            new PJQ.Loader(this.$('.modal-content'));
            this.options.onSaveWait(data, () => {
                this.removeModal();
            });
        } else {
            this.removeModal();
        }
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
    },
});

PJQ.views.email.ContactSearchSelect = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'contact-email-search-select'),
        subTemplates: {
            contact: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Contact')
        },
        search: ''
    },
    events: {
        'click .share-contact': 'addEmail',
    },
    beforeFirstRender: function () {
        this.selectedEmails = this.options.selectedEmails;
        this.render();
    },
    afterRender: function () {
        if (this.options.project != null) {
            let contactsLoader = new PJQ.Loader(this.$('.share-contacts-outer'));
            this.options.project.fetchProjectContacts(_.bind(function (projectContacts) {
                this.contacts = projectContacts;
                contactsLoader.remove();
                this.searchChanged(this.options.search);
            }, this));
        } else {
            this.contacts = new PJQ.collections.contacts.Contacts();
            this.searchChanged(this.options.search);
        }
    },
    searchChanged: function (searchVal) {
        let searchText = searchVal != null ? searchVal : "",
            filteredContacts;
        if (_.size(searchText) > 0) {
            filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
                let email = contact.get('email').toLowerCase();
                if (_.size(email) === 0 || _.indexOf(this.selectedEmails, email) !== -1) {
                    return false;
                }

                return contact.get('contactName').toLowerCase().indexOf(searchText) !== -1 || email.indexOf(searchText) !== -1;
            }, this));
        } else {
            filteredContacts = _.filter(this.contacts.models, _.bind(function (contact) {
                let email = contact.get('email').toLowerCase();
                return _.size(email) > 0 && _.indexOf(this.selectedEmails, email) === -1;
            }, this))
        }

        let $addEmail = this.$('.share-add-email'),
            isValidEmail = PJQ.helpers.validators.validateEmail(searchText).success;
        if (isValidEmail && _.size(filteredContacts) === 0) {
            this.$('.share-suggested-contacts').append($('<div>', {
                text: searchText
            }));
            this.$('.share-add-email .share-contact').data('email', searchText);
            this.$('.share-email-entry-letter').html(searchText[0].toUpperCase());
            this.$('.share-email-entry').text(searchText);
            $addEmail.removeClass('hidden');
        } else {
            $addEmail.addClass('hidden');
        }

        let $searchResults = this.$('.share-search-results'),
            $searchResultsOuter = this.$('.share-search-results-outer');
        $searchResults.empty();
        if (_.size(filteredContacts) > 0) {
            _.each(_.sortBy(filteredContacts, function (contact) {
                return contact.get('contactName')
            }), _.bind(function (contact) {
                this.renderSubTemplate(true, this.options.subTemplates.contact, $searchResults, {
                    model: contact
                });
            }, this));

            $searchResultsOuter.removeClass('hidden');
        } else {
            $searchResultsOuter.addClass('hidden');
        }

        let $noResults = this.$('.share-search-no-results');
        if (isValidEmail || _.size(filteredContacts) > 0) {
            $noResults.addClass('hidden');
        } else {
            $noResults.removeClass('hidden');
        }
    },
    addEmail: function (e) {
        let email = $(e.currentTarget).closest('.share-contact').data('email');
        this.selectedEmails.push(email.toLowerCase());
        this.searchChanged();
        if (typeof this.options.onAdd === 'function') {
            this.options.onAdd(email)
        }
    },
})